import React from 'react'

import ElementBase from './ElementBase'
import ElementTextarea from './components/ElementTextarea'
import ComponentImage from './components/Image'

class ElementIntroslider extends ElementBase {
  constructor(props) {
    super(props)

    this.state = {
      activeSlide: 0
    }
  }

  slidePrev() {
    var nextActiveSlide = this.state.activeSlide - 1
    if(this.props.element.settings === undefined || this.props.element.settings.slides === undefined) {
      nextActiveSlide = 0
    } else if(nextActiveSlide < 0) {
      nextActiveSlide = this.props.element.settings.slides.length - 1
    }
    this.setState({
      activeSlide: nextActiveSlide
    })
  }

  slideNext() {
    var nextActiveSlide = this.state.activeSlide + 1
    if(this.props.element.settings === undefined || this.props.element.settings.slides === undefined || nextActiveSlide >= this.props.element.settings.slides.length) {
      nextActiveSlide = 0
    }
    this.setState({
      activeSlide: nextActiveSlide
    })
  }

  html() {
    var slidesImages = []
    var slidesContent = []
    if(this.props.element.settings !== undefined && this.props.element.settings.slides !== undefined && this.props.element.settings.slides.length > 0) {
      slidesImages = this.props.element.settings.slides.map((slide, index) => {
        return(
          <div
            key={index}
            className={'slide' + (index === this.state.activeSlide ? ' active' : '')}
          >
            <div className="image">
              <ComponentImage
                id={slide.settings.image}
              />
            </div>
          </div>
        )
      })
      slidesContent = this.props.element.settings.slides.map((slide, index) => {
        return(
          <div
            key={index}
            className={'slide' + (index === this.state.activeSlide ? ' active' : '')}
          >
            <div className="headline h2">
              <ElementTextarea
                {...this.props}
                fieldName="headline"
                text={slide.settings.headline}
                placeholder="Titel..."
                repeaterFieldName="slides"
                itemId={slide.id}
              />
              { /* customized start */ }
                <div className="separator"></div>
              { /* customized end */ }
            </div>
            <hr />
            <div className="text">
              <ElementTextarea
                {...this.props}
                fieldName="text"
                text={slide.settings.text}
                placeholder="Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua."
                repeaterFieldName="slides"
                itemId={slide.id}
              />
            </div>
          </div>
        )
      })
    }
    return(
      <div className="introslider">
        <div className="slider-images">
          <div className="slides">{slidesImages}</div>
        </div>
        <div className="slider-content">
          <div className="slides">{slidesContent}</div>
        </div>
        <div className="slider-arrows">
          <div
            className="slider-arrow"
            onClick={this.slidePrev.bind(this)}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="22.245" height="37.42" viewBox="0 0 22.245 37.42">
              <path d="M-4584.77-12003.848l16.942,16.942,16.942-16.942" transform="translate(-11983.37 4586.537) rotate(90)" strokeWidth="5" />
            </svg>
          </div>
          <div
            className="slider-arrow"
            onClick={this.slideNext.bind(this)}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="22.245" height="37.42" viewBox="0 0 22.245 37.42">
              <path d="M-4584.77-12003.848l16.942,16.942,16.942-16.942" transform="translate(12005.615 -4549.117) rotate(-90)" strokeWidth="5" />
            </svg>
          </div>
        </div>
      </div>
    )
  }
}

export default ElementIntroslider
